import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { DialogAutoFocusModule } from '@portal-core/ui/dialog/directives/dialog-auto-focus/dialog-auto-focus.module';
import { UserProfileModule } from '@portal-core/users/components/user-profile/user-profile.module';
import { UserProfileDialogComponent } from './user-profile-dialog.component';

@NgModule({
  declarations: [
    UserProfileDialogComponent
  ],
  imports: [
    CommonModule,
    DialogAutoFocusModule,
    ErrorsExpansionPanelModule,
    LoaderModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    UserProfileModule
  ],
  exports: [
    UserProfileDialogComponent
  ]
})
export class UserProfileDialogModule { }
